<template>
  <v-container fluid id="about" pa-0>
    <v-parallax
      :src="require('../assets/turned-on-light-crane.jpg')"
    >
      <v-row no-gutters>
        <v-container class="about-content">
          <v-row no-gutters>
            <v-card
              flat
              tile
              max-width="300"
              color="primary"
              dark
            >
              <v-card-title class="headline"><b>{{$t('about.title')}}</b></v-card-title>
              <v-card-text style="color: white; font-size: 0.95rem;">
                {{$t('about.text')}}
              </v-card-text>
            </v-card>
          </v-row>
        </v-container>
      </v-row>
    </v-parallax>
  </v-container>
</template>

<script>
  export default {
    name: 'About'
  }
</script>

<style scoped>
  .about-content {
    /*background: #000000 url('../assets/turned-on-light-crane.jpg') no-repeat center center;*/
    /*background-size: cover;*/
    padding-top: 100px;
    padding-bottom: 100px;
  }
</style>
